import { render, staticRenderFns } from "./CurveShapeButton.vue?vue&type=template&id=50fd08cb&scoped=true&lang=pug&"
import script from "./CurveShapeButton.vue?vue&type=script&lang=js&"
export * from "./CurveShapeButton.vue?vue&type=script&lang=js&"
import style0 from "./CurveShapeButton.vue?vue&type=style&index=0&id=50fd08cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd08cb",
  null
  
)

export default component.exports